module.exports = __webpack_public_path__ + "img/tbtp.b11db58f.png";